var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('HeaderDefault'),_c('HeroClinic'),_c('ClinicFeatureSection'),_c('ClinicWorkStep'),_c('ClinicCounterup'),_c('ClinicPricing'),_c('Newsletter'),_c('FooterMain'),_c('OffcanvasSearchBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }